import axiosApiClient from '..';
import { handleError, throwErrorIfWrongStatus } from './utils';

const BASE_URL = '/d/asset-folders';

class AssetFolderService {
  fetchAssetFolders = async influencerId => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.get(`${BASE_URL}?${params.toString()}`);
      throwErrorIfWrongStatus(response, 200);
      const { folders } = response.data.data;
      return { folders };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching folders.');
    }
  };

  createAssetFolders = async (name, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.post(`${BASE_URL}?${params.toString()}`, { name });
      throwErrorIfWrongStatus(response, 200);
      const { folder } = response.data.data;
      return { folder };
    } catch (err) {
      throw handleError(err, 'Error occurred while creating folder.');
    }
  };

  fetchAssetFolderById = async (folderId, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.get(`${BASE_URL}/${folderId}?${params.toString()}`);
      throwErrorIfWrongStatus(response, 200);
      const { folder } = response.data.data;
      return { folder };
    } catch (err) {
      throw handleError(err, 'Error occurred while fetching folder.');
    }
  };

  deleteAssetFolder = async (assetFolderId, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.delete(`${BASE_URL}/${assetFolderId}?${params.toString()}`);
      throwErrorIfWrongStatus(response, 200);
      return { assetFolderId };
    } catch (err) {
      throw handleError(err, 'Error occurred while deleting folder.');
    }
  };

  editAssetFolder = async (assetFolderId, name, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.put(`${BASE_URL}/${assetFolderId}?${params.toString()}`, { name });
      throwErrorIfWrongStatus(response, 200);
      return { assetFolderId, name };
    } catch (err) {
      throw handleError(err, 'Error occurred while editing folder.');
    }
  };

  addMediaToAssetFolder = async (assetFolderId, media, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.post(`${BASE_URL}/${assetFolderId}?${params.toString()}`, { media });
      throwErrorIfWrongStatus(response, 200);
      const { numOfPhotos, numOfVideos } = response.data.data;
      return { assetFolderId, numOfPhotos, numOfVideos };
    } catch (err) {
      throw handleError(err, 'Error occurred while adding media to asset folder.');
    }
  };

  removeMediaFromAssetFolder = async (assetFolderId, media, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const response = await axiosApiClient.post(`${BASE_URL}/remove-media/${assetFolderId}?${params.toString()}`, {
        media,
      });
      throwErrorIfWrongStatus(response, 200);
      const { numOfPhotos, numOfVideos } = response.data.data;
      return { assetFolderId, numOfPhotos, numOfVideos };
    } catch (err) {
      throw handleError(err, 'Error occurred while removing media from asset folder.');
    }
  };

  changeAssetsMediaPositionFolder = async (assetFolderId, mediaPositions, influencerId) => {
    try {
      const params = new URLSearchParams();
      if (influencerId) {
        params.append('influencerId', influencerId);
      }
      const body = { mediaPositions };
      const response = await axiosApiClient.post(
        `${BASE_URL}/change-position/${assetFolderId}?${params.toString()}`,
        body,
      );
      throwErrorIfWrongStatus(response, 200);
    } catch (err) {
      throw handleError(err, 'Error occurred while changing media position in folder');
    }
  };
}

export default new AssetFolderService();
